import { MonitorCog, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';

const themeLabels = {
  light: 'Light',
  dark: 'Dark',
  system: 'Auto',
} as const;

export function ThemeModeMenu() {
  const { theme = 'system', resolvedTheme, setTheme } = useTheme();
  const resolvedLabel =
    theme === 'system'
      ? `System ${resolvedTheme === 'dark' ? 'dark' : 'light'}`
      : themeLabels[theme as keyof typeof themeLabels];

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <MonitorCog className="mr-2 h-4 w-4" />
        <span className="leading-none">Appearance</span>
        <span className="ml-auto text-xs leading-none text-muted-foreground">{resolvedLabel}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-44">
        <DropdownMenuRadioGroup value={theme}>
          <DropdownMenuRadioItem
            value="light"
            onSelect={() => {
              setTheme('light');
            }}
          >
            <Sun className="mr-2 h-4 w-4" />
            Light
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem
            value="dark"
            onSelect={() => {
              setTheme('dark');
            }}
          >
            <Moon className="mr-2 h-4 w-4" />
            Dark
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem
            value="system"
            onSelect={() => {
              setTheme('system');
            }}
          >
            <MonitorCog className="mr-2 h-4 w-4" />
            Auto
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
